declare global {
	interface Array<T> {
		dynamicSort(fields: any[], desc?: boolean): Array<T>;
	
		dynamicFilter(fields: any[]): Array<T>;
	
		sum(field?: string): number;
	
		remove(callbackFn: (value: T) => unknown): Array<T>;
	
		removeAll(): Array<T>;
		removeLast(): T;
	
		split(size: number): Array<T>;
	
		firstOrDefault(callbackFn?: (value: T) => unknown): T;
		groupBy(key: string): any;
	
		lastOrDefault(callbackFn?: (value: T) => unknown): T;
	
		insertBefore(currentIndex: number, insertItem: T): void;
		insertAfter(currentIndex: number, insertItem: T): void;
	
		any(callbackFn?: (value: T) => unknown): boolean;
	
		count(callbackFn: (value: T) => unknown): number;
	
		pushRange(items: T[]): Array<T>;
	
		distinct(field: string): Array<T>;
	
		findMissingDays(): Array<Date>;
	}
}

Array.prototype.dynamicSort = function (fields: any[], desc: boolean = false) {
	const _self = this as Array<any>;
	if (fields) {
		fields.forEach((field) => {
			_self.sort((a, b) => {
				if (desc) {
					return b[field] > a[field] ? 1 : -1;
				}

				return a[field] > b[field] ? 1 : -1;
			});
		});
	}

	return _self;
};

Array.prototype.pushRange = function <T>(items: T[]) {
	const self = this;
	items.forEach(item => {
		self.push(item);
	});

	return self;
};

Array.prototype.dynamicFilter = function (fields) {
	let _self = this as Array<any>;
	// if (!!fields){
	// if (typeof (fields[0]) !== 'string') {
	// for (let i=0;i< fields.length; i= i+2){
	// _self =_self.filter(o => o[fields[i][0]].includes(fields[i][2]));
	// }
	// }
	// else{
	// _self =_self.filter(o => o[fields[0]].includes(fields[2]));
	// }
	// }

	return _self;
};

Array.prototype.sum = function (field?: string) {
	if (field)
		return this.reduce((a, b) => a + (b[field] || 0), 0);
	else
		return this.reduce((a, b) => a + (b || 0), 0);
};

Array.prototype.remove = function <T>(callbackFn: (value: T) => unknown) {
	const removingItems = this.filter(callbackFn);
	if (removingItems && removingItems.length > 0) {
		let l = removingItems.length;
		let itemIndex = -1;
		let item;
		while (l && this.length) {
			item = removingItems[--l];
			itemIndex = this.indexOf(item);
			if (itemIndex !== -1) {
				this.splice(itemIndex, 1);
				itemIndex = -1;
			}
		}
	}

	return removingItems;
};

Array.prototype.removeAll = function <T>() {
	let l = this.length;
	let itemIndex = -1;
	let item;
	while (l && this.length) {
		item = this[--l];
		itemIndex = this.indexOf(item);
		if (itemIndex !== -1) {
			this.splice(itemIndex, 1);
			itemIndex = -1;
		}
	}

	return this;
};

Array.prototype.removeLast = function <T>() {
	return this.splice(this.length - 1, 1)[0];
};

Array.prototype.any = function <T>(callbackFn?: (value: T) => unknown) {
	const items = callbackFn ? this.filter(callbackFn) : this;

	return items && items.length > 0;
};

Array.prototype.groupBy = function (key: string) {
	return this.reduce(function(rv, x) {
		(rv[x[key]] = rv[x[key]] || []).push(x);
		return rv;
	  }, {});
};

Array.prototype.split = function <T>(size: number) {
	const list = [];
	const length = this.length;
	
	for (let i = 0; i < length; i += size) {
		list.push(this.splice(0, Math.min(size, length - i)));
	}

	return list;
};

Array.prototype.firstOrDefault = function <T>(callbackFn?: (value: T) => unknown) {
	let items;
	if (callbackFn)
		items = this.filter(callbackFn);
	else items = this;
	if (items && items.length > 0) {
		return items[0];
	}

	return null;
};

Array.prototype.lastOrDefault = function <T>(callbackFn?: (value: T) => unknown) {
	let items;
	if (callbackFn)
		items = this.filter(callbackFn);
	else items = this;

	if (items && items.length > 0)
		return items[items.length - 1];

	return null;
};


Array.prototype.insertBefore = function <T>(currentIndex: number, insertItem: T): void {
	this.splice(currentIndex, 0, insertItem);
};

Array.prototype.insertAfter = function <T>(currentIndex: number, insertItem: T): void {
	this.splice(currentIndex + 1, 0, insertItem);
};

Array.prototype.count = function <T>(callbackFn: (value: T) => unknown) {
	const matchConditionItems = this.filter(callbackFn);
	if (matchConditionItems) {
		return matchConditionItems.length;
	}

	return 0;
};

Array.prototype.distinct = function (field: string) {
	const _self = this as Array<any>;
	const unique: Array<any> = [];
	const distinct: Array<any> = [];

	for (let i = 0; i < _self.length; i++) {
		const value = _self[i][field];

		if (!unique.any(_ => _ === value)) {
			distinct.push(_self[i]);
			unique.push(value);
		}
	}

	return distinct;
};

Array.prototype.findMissingDays = function () {
	const array = this;

	const result = array.sort(function (a, b) {
		return Date.parse(a) - Date.parse(b);
	}).reduce(function (hash) {
		return function (p, c) {
			const missingDaysNo = (Date.parse(c) - hash.prev) / (1000 * 3600 * 24);
			if (hash.prev && missingDaysNo > 1) {
				for (let i = 1; i < missingDaysNo; i++)
					p.push(new Date(hash.prev + i * (1000 * 3600 * 24)));
			}
			hash.prev = Date.parse(c);
			return p;
		};
	}(Object.create(null)), []);

	return result;
};

export {};